const translations = {
    comingSoon: 'This feature is coming soon!',
    title: "We're working on it"
};

export default translations;
